import { jsx, jsxs } from "react/jsx-runtime";
import { FlipWords } from "../../Components/ui/flip-words.js";
import { useSuggestedQueries } from "../../api/cache/appConfigQueryOptions.js";
import { useTheme } from "@mui/material";
import { Sparkles } from "lucide-react";
import { memo, useMemo } from "react";
import { AnimatedMasonryGrid } from "./AnimatedMasonryGrid.js";
import { ConciergeWelcomeEmbedded } from "./ConciergeWelcomeEmbedded.js";
import { usePageContext } from "../hooks/usePageContext.js";
function FlipWordsDemo() {
  const words = [
    "find the perfect gift for your mom",
    "save on your weekly grocery shopping",
    "find a Halloween costume for your dog"
  ];
  const theme = useTheme();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "tw:text-4xl tw:font-bold tw:text-left tw:max-w-[350px] md:tw:max-w-[500px] tw:h-[200px] md:tw:h-[200px] tw:pl-[18px] md:tw:pl-[43px]",
      style: {
        color: theme.palette.text.primary
      },
      children: [
        "Use Concierge to ",
        /* @__PURE__ */ jsx(FlipWords, { words, duration: 4e3 })
      ]
    }
  );
}
const ConciergeWelcomeComponent = ({
  trendingSearches,
  onSearch,
  brandId,
  isEmbedded = false,
  apiBaseUrl,
  userFirstName: _userFirstName,
  pageContext: providedPageContext
}) => {
  const { data, isLoading: isLoadingSuggestedQueries } = useSuggestedQueries(brandId, apiBaseUrl);
  const theme = useTheme();
  const suggestedQueries = useMemo(
    () => (data == null ? void 0 : data.suggestedQuestions) || (trendingSearches == null ? void 0 : trendingSearches.map((search) => ({ query: search.text, imageUrl: "" }))) || [],
    [data == null ? void 0 : data.suggestedQuestions, trendingSearches]
  );
  const displayQueries = useMemo(() => suggestedQueries.map((item) => item.query), [suggestedQueries]);
  const hookPageContext = usePageContext();
  const pageContext = providedPageContext ?? hookPageContext;
  if (isEmbedded) {
    return /* @__PURE__ */ jsx(
      ConciergeWelcomeEmbedded,
      {
        displayQueries,
        isLoadingSuggestedQueries,
        onSearch,
        pageContext,
        apiBaseUrl
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
        textAlign: "center",
        width: "100%",
        height: "100%",
        boxSizing: "border-box",
        overflow: "auto"
      },
      children: [
        /* @__PURE__ */ jsx(FlipWordsDemo, {}),
        displayQueries.length > 0 && !isLoadingSuggestedQueries && /* @__PURE__ */ jsxs("div", { style: { width: "100%", maxWidth: "1200px" }, children: [
          /* @__PURE__ */ jsxs(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                marginBottom: "28px"
              },
              children: [
                /* @__PURE__ */ jsx(
                  Sparkles,
                  {
                    style: {
                      width: "18px",
                      height: "18px",
                      color: theme.palette.text.secondary
                    }
                  }
                ),
                /* @__PURE__ */ jsx(
                  "h3",
                  {
                    style: {
                      fontSize: "15px",
                      fontWeight: "600",
                      color: theme.palette.text.secondary,
                      margin: 0,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em"
                    },
                    children: "For you"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsx(AnimatedMasonryGrid, { items: displayQueries, onItemClick: onSearch })
        ] })
      ]
    }
  );
};
const ConciergeWelcome = memo(ConciergeWelcomeComponent);
export {
  FlipWordsDemo,
  ConciergeWelcome as default
};
//# sourceMappingURL=ConciergeWelcome.js.map
